<style>
    .shopify-product-card{
        /*width: 220px;*/
        width: 100%;
        border: none;
        box-shadow: none;
        background: transparent;
        /*padding-right: 10px;*/
    }
    .shopify-product-card .product-price{
        font-size: 20px;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -0.4px;
    }
    .shopify-product-card .store-name{
        font-size: 13px;
        line-height: normal;
        letter-spacing: -0.26px;
        color: var(--text-subtle);
    }
    .shopify-product-card .discount-badge{
        display: inline-block;
        color: var(--primary);
        padding: 3px 4px;
        background: #ECF3E7;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.24px;
    }
    [data-theme="dark"] .shopify-product-card .discount-badge{
        background: #ecf3e70d;
    }
    .shopify-product-card.large img.product-image {
        display: block;
        width: 100%;
        height: auto;
        min-height: 160px;
        max-height: 424px;
       /* border-radius: 5px;*/
        border-radius: 24px;
        object-fit: contain;
        background-color: transparent;
    }
    .shopify-product-card.large img.store-image {
        display: block;
        width: 16px;
        height: 16px;
        object-fit: cover;
        background: white;
    }
    .shopify-product-card .product-description-container {
        overflow: hidden;
        max-height: 52px;
    }
    .shopify-product-card .product-description-container.expanded {
        max-height: none;
    }
    .shopify-product-card .product-external-link {
        color: var(--text-color);
        padding: 4px 12px 4px 12px;
        border-radius: 200px;
        background-color: var(--default);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        max-width: 100%;
        font-size: var(--font-size);
    }
    .shopify-product-card .product-bottom-overlay {
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0px;
        opacity: 0;
        transition: 0.2s;
        padding: 12px 12px;
    }
    .shopify-product-card:hover .product-bottom-overlay {
        opacity: 1;
    }
    .shopify-product-card .product-save-overlay {
        position: absolute;
        top: 12px;
        right: 12px;
        max-width: calc(100% - 24px);
        /*opacity: 0;*/
    }
    .shopify-product-card:hover .product-save-overlay {
        /*opacity: 1;*/
    }
    .shopify-product-card .overlay-hide{
        transition: 0.2s;
        opacity: 0;
    }
    .shopify-product-card:hover .overlay-hide{
        opacity: 1;
    }
    .shopify-product-card .product-right-overlay-2{
        position: absolute;
        top: 50px;
        right: 12px;
    }

    .shopify-product-card .product-title{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
        display: inline-block;
        font-size: 13px;
        line-height: 16px; /* 123.077% */
        letter-spacing: -0.26px;
    }
    .shopify-product-card .image-overlay{
        position: absolute;
        background: rgba(0, 0, 0, .02);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 24px;
    }
    .shopify-product-card .badge-primary {
        background-color: var(--primary);
        color: white;
    }
    .shopify-product-card .badge {
        padding: 2px 4px;
        border-radius: 200px;
    }
    .shopify-product-card .text-decoration-line-through{
        text-decoration: line-through;
    }
    
    .shopify-product-card .product-bottom-overlay .btn-icon{
        width: 24px !important;
        height: 24px !important;
    }
    @media (max-width: 576px) {
        .shopify-product-card .overlay-hide{
            opacity: 1;
        }

        .shopify-product-card .btn-more{
            width: 48px;
            height: 48px;
        }

        .shopify-product-card  .col-more{
            padding-top:20px;
        }
    }
</style>

<script>
    import 'lazysizes';

    import saveGroupButtons from '../group/saveGroupButtons';
    
    import {shopifyProductStructuredDataMixin} from "../../mixins/shopify/shopifyProductStructuredDataMixin";
    import {shopifyHelperMixin} from "../../mixins/shopifyHelperMixin";

    export default {
        props: ['product', 'preview', 'disable_groups', 'enable_structured_data'],
        components: {
            saveGroupButtons
        },
        mixins: [shopifyProductStructuredDataMixin, shopifyHelperMixin],
        data: function () {
            return {
                loading: {
                    watchlist: false
                },
                has_show_more_text_button: false,
                show_more_text: false,
                groups: [],
                selected_group: null,
                watchlist: null
            }
        },
        computed: {
            title: function(){
                return this.product.title;
            },
            description: function(){
                return this.product.custom_description || this.product.description;
            },
            price: function(){
                if(this.product.unit_price >= 0){
                    return this.formatCurrency(this.product.unit_price);
                }
                if(this.product.variants && this.product.variants.length){
                    var price = this.product.variants[0].price;
                    price = price.match(/[\d.]+/)[0];
                    return this.formatCurrency(price * 100);
                }

            },
            product_url: function(){
                if(this.product.profile_url){
                    return this.product.profile_url;
                }
                return this.shopify_url;
            },
            shopify_url: function(){
                var store = this.product.shop;
                if(!store || !store.domain || !this.product.handle){
                    return;
                }
                var base_url = 'https://' + store.domain;
                var url = base_url + '/products/' + this.product.handle;
                return url;
            },
            host: function(){
                var store = this.product.shop;
                if(store && store.domain){
                    return store.domain;
                }
                if(!this.shopify_url){
                    if(this.preview){
                        return 'example.com';
                    }
                    return;
                }
                try {
                    var url_object = new URL(this.product_url);
                    if(url_object && url_object.host){
                        return url_object.host.replace('www.', '');;
                    }
                } catch (e){}
            },
            image_url: function(){
                if(this.product.images && this.product.images.length && this.product.images[0].src){
//                    this.setThumbnails(this.product);
//                    return this.product.thumbnail;
                    return this.resizeImage(this.product.images[0].src);
                }
                return this.product.image_url || '/img/product_placeholder.png';
            },
            image_title: function(){
                var title = this.product.title;
                if(this.product.shop){
                    title += ' - ' + this.product.shop.name;
                }
                if(this.product.subcategory){
                    title += ' - ' + this.product.subcategory;
                } else if(this.product.main_category){
                    title += ' - ' + this.product.main_category;
                }
                return title;
            },
            image_height: function(){
                var height = 80;
                if(this.product.images && this.product.images.length && this.product.images[0].src){
                    height = this.product.images[0].height || 80;
                }
                return height;
            },
            image_width: function(){
                var width = 80;
                if(this.product.images && this.product.images.length && this.product.images[0].src){
                    width = this.product.images[0].width || 80;
                }
                return width;
            },
            store_logo_url: function(){
                if(!this.product.shop || !this.product.shop.logo){
                    return;
                }
                return this.product.shop.logo;
            },
            discount_percentage: function(){
                var last_price_change = this.product.last_price_change || 0;
                if(last_price_change < 0){
                    return Math.abs(last_price_change);
                }
            },
            previous_price: function(){
                if(this.discount_percentage > 0){
                    if(this.discount_percentage === 100){
                        return;
                    }
                    var previous_price = this.product.unit_price / (1 - this.discount_percentage / 100);
                    previous_price = Math.round(previous_price / 100) * 100;
                    return previous_price;
                }
            }
        },
        created: function () {
            var self = this;
        },
        mounted: function () {
            var self = this;
            
            this.setShowMoreText();
            
            window.bus.$on('watchlist-loaded', function(watchlist){
                self.watchlist = watchlist;
                self.setWatchlistFlag();
            });

            if(typeof watchlist === 'object'){
                this.watchlist = watchlist;
                this.setWatchlistFlag();
            }
        },
        methods: {
            formatCurrency: function(unit_amount){
                var num = unit_amount / 100; //convert to dollars
                num = num.toLocaleString('en-US', {
                    style: 'currency',
                    currency:'USD',
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                });
                return num;
            },
            setShowMoreText: function(){
                if (this.product && this.product.uuid) {
                    var el = document.getElementById('shopify-product-description-' + this.product.uuid);
                    this.has_show_more_text_button = el && el.clientHeight > 52;
                }
            },
            toggleShowMoreText: function(){
                this.show_more_text = !this.show_more_text;
            },
            searchProduct: function(){
                window.bus.$emit('update_global_search', this.product.title);
            },
            onGroupUpdated: function(data){
                var group = data.group;
                var groups = this.groups || [];
                for(var i=0; i < groups.length; i++){
                    if(groups[i].uuid === group.uuid){
                        Object.assign(groups[i], group);
                        break;
                    }
                }
            },
            onSelectedGroup: function(group){
                this.selected_group = group;
            },
            onLoadedGroups: function(groups){
                this.groups = groups;
            },
//            resizeImage: function(url, size){
//                if(!url.includes('cdn.shopify.com')){
//                    return url;
//                }
//                size = size || '_300x';
//                var regex = /\.(jpg|webp|png)/;
//                url = url.replace(regex, size + '.$1');
//                return url;
//            },
            onImageError: function(event){
                var img = event.target;
                img.onerror = null;
                img.src = '/img/product_placeholder.png';
                img.style.aspectRatio = this.image_width / this.image_height;
                img.style.backgroundColor = '#777f8e';
            },
            toggleWatchlist: function(){
                if(!this.auth_user){
                    window.bus.$emit('show_login_form');
                    return;
                }
                
                if(this.product._in_watchlist){
                    this.removeFromWatchlist();
                } else {
                    this.addToWatchlist();
                }
            },
            addToWatchlist: function(){
                var self = this;
                if(self.loading.watchlist) {
                    return;
                }
                self.loading.watchlist = true;
                var url = '/api/v5/shop/watchlist/add';
                var params = {
                    product_ids: [this.product.id],
                    append: ['products']
                };
                axios.post(url, params).then(function (response) {
                    self.watchlist = response.data.data;
                    self.loading.watchlist = false;
                    self.setWatchlistFlag();
                    self.showWatchlistSnackbar(true);
                    window.bus.$emit('watchlist-edited', self.watchlist);
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.loading.watchlist = false;
                });
            },
            removeFromWatchlist: function(){
                var self = this;
                if(self.loading.watchlist) {
                    return;
                }
                self.loading.watchlist = true;
                var url = '/api/v5/shop/watchlist/remove';
                var params = {
                    product_ids: [this.product.id],
                    append: ['products']
                };
                axios.post(url, params).then(function (response) {
                    self.watchlist = response.data.data;
                    self.loading.watchlist = false;
                    self.setWatchlistFlag();
                    self.showWatchlistSnackbar(false);
                    window.bus.$emit('watchlist-edited', self.watchlist);
                }).catch(function (error) {
                    Raven.captureMessage(JSON.stringify(error));
                    self.loading.watchlist = false;
                });
            },
            setWatchlistFlag: function(){
                if(!this.product){
                    return;
                }
                var product_ids = this.watchlist.product_ids || [];
                var in_watchlist = product_ids.includes(this.product.id);
                Vue.set(this.product, '_in_watchlist', in_watchlist);
            },
            showWatchlistSnackbar: function(added){
                var self = this;
                var snackbar = {
                    pos: 'bottom-center'
                };
                if(this.image_url){
                    snackbar.image_url = this.image_url;
                }
                
                if(added){
                    snackbar.text = 'Item added to your <strong>watchlist</strong>';
                    snackbar.action_text = 'Undo';
                    snackbar.action_callback = function(){
                        self.removeFromWatchlist();
                    };
                } else {
                    snackbar.text = '<strong>Item removed from watchlist!</strong>';
                }
                if(typeof RDSnackbar === 'object'){
                    RDSnackbar.show(snackbar);
                } else {
                    Snackbar.show(snackbar);
                }
            }
        }
    };

</script>

<template>
    <article class="card shopify-product-card large" v-if="product">
        
        <script type="application/ld+json" v-if="enable_structured_data">
            {{product_structured_data}}
        </script>
        
        <div class="card-body p-0">
            <div class="position-relative">
                <a class="d-block" :href="product_url">
                    <div class="image-overlay"></div>
                    <img :data-pid="product.id" class="product-image lazyload" crossOrigin :data-src="image_url" v-if="image_url" :height="image_height" :width="image_width" @error="onImageError"  :alt="image_title" :style="{'aspect-ratio': image_width / image_height}">
                </a>
                <div class="product-save-overlay" v-if="!disable_groups">
                    <save-group-buttons :item="product"></save-group-buttons>
                </div>
                <div class="product-right-overlay-2 overlay-hide">
                    <div class="row row-xs justify-content-end flex-nowrap">
                        <div class="col-auto">

                        </div>
                        <div class="col-auto col-more">
                            <button class="btn btn-default rounded-pill btn-more" style="padding: 7px 8px;" @click="searchProduct" title="More like this">
                                <i class="fas fa-search fa-fw"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="product-bottom-overlay overlay-hide">
                    <div class="row row-sm flex-nowrap align-items-center justify-content-between">
                        <div class="col overflow-hidden fs-0">
                            <a class="product-external-link" :href="product_url" v-if="host && product_url">
                                {{host}} <i class="ml-1 fas fa-external-link-alt fa-fw"></i>
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-icon btn-default rounded-pill" :class="{'btn-primary': product._in_watchlist}" @click="toggleWatchlist" :title="product._in_watchlist ? 'Remove from watchlist' : 'Add to watchlist'">
                                <i class="fas fa-eye fa-fw"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="px-1 pb-3" style="margin-top: 10px">
                <div class="row row-xs">
                    <div class="col-auto">
                        <div>
                            <div class="d-inline-block align-middle product-price">{{price}}</div>
                            <div class="d-inline-block align-middle ml-1" v-if="discount_percentage > 0 && discount_percentage < 100 && previous_price" style="font-size:13px;">
                                <span class="text-subtle" style="opacity: 0.6;"><span class="text-decoration-line-through">{{formatCurrency(previous_price)}}</span></span>
                            </div>
                        </div>
                        <div class="mb-2" v-if="discount_percentage > 0 && discount_percentage < 100 && previous_price" style="font-size:13px;">
                            <span class="discount-badge">You save</span>
                            <span class="text-primary font-weight-bold">{{formatCurrency(previous_price - product.unit_price)}}</span>
                        </div>
                        
                    </div>
                    <div class="col-12">
                        <h4 class="product-title mb-0">
                            <a :href="product_url" class="text-reset font-weight-normal" :title="title">{{title}}</a>
                        </h4>
                    </div>
                </div>
                <div class="row no-gutters flex-nowrap align-items-center" style="min-height: 20px" v-if="product.shop">
                    <div class="col-auto mr-1" v-if="store_logo_url">
                        <a class="text-reset" :href="product.shop.profile_url || product.shop.url">
                            <img :data-sid="product.shop_id" class="store-image rounded-circle lazyload" :data-src="store_logo_url" :alt="product.title">
                        </a>
                    </div>
                    <div class="col">
                        <a class="text-reset" :href="product.shop.profile_url || product.shop.url">
                            <span class="store-name"> {{product.shop.name}} </span>
                        </a>
                    </div>
                </div>

               <!-- <div class="product-description-container" :class="{expanded: show_more_text}">
                    <p class="text-subtle mb-1" :id="'shopify-product-description-' + product.uuid">{{product.description}}</p>
                </div>-->
                <div class="my-1" v-if="has_show_more_text_button">
                    <span class="pointer text-primary" @click="toggleShowMoreText()" v-if="!show_more_text">Show More</span>
                    <span class="pointer text-primary" @click="toggleShowMoreText()" v-else>Show Less</span>
                </div>
            </div>

        </div>
    </article>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/shopify/shopifyProductCard.vue